<div class="formula-meta">
  <div class="row">
    <app-textarea [formGroup]="$safeNavigationMigration(model()?.meta?.formGroup)" [model]="model()?.type?.data?.script || defaultScript" [meta]="metaScript"></app-textarea>
  </div>
</div>
